import { Reveal } from "@/lib/motion";
import { useBrochureGate } from "./Growth";

export function About() {
  const brochure = useBrochureGate();
  return (
    <section id="about" data-testid="about-section" className="bg-[#f3f3e9] py-20 lg:py-28">
      <div className="wrap grid gap-12 lg:grid-cols-[1fr_1.4fr]">
        <Reveal>
          <div className="eyebrow text-[#5c6b5a]">01 / The conclave</div>
          <h2 className="mt-4 font-display text-3xl leading-tight sm:text-5xl">
            Rooted in purpose.
            <br />
            <em className="italic">Growing through connection.</em>
          </h2>
        </Reveal>
        <div>
          <Reveal delay={0.08}>
            <p className="font-display text-xl leading-snug sm:text-2xl">
              Where the organic food ecosystem comes together to turn opportunity into action.
            </p>
            <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-[#3d5247]">
              OFIC 2026 brings the organic agri food business into focus — connecting growers, processors, traders, brands, investors and policy makers. Explore emerging technologies, market trends and collaborations that move the industry forward.
            </p>
            <button data-testid="about-brochure-download" onClick={brochure} className="ofic-btn ofic-btn-forest mt-8">
              Download brochure <span className="arrow">↓</span>
            </button>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 rounded-xl p-6" style={{ background: "#fbfbf4", border: "1px solid var(--line)" }} data-testid="about-audience">
              <span className="eyebrow text-[#5c6b5a]">A place for</span>
              <p className="mt-2 text-[15px] font-bold leading-relaxed sm:text-lg">
                Growers & producers <b className="text-[#5c6b5a]">↗</b> Brands & retailers <b className="text-[#5c6b5a]">↗</b> Exporters & buyers <b className="text-[#5c6b5a]">↗</b> Investors & innovators <b className="text-[#5c6b5a]">↗</b> Policy makers & researchers
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

const REASONS = [
  ["A", "Market insight", "Achieve", "Understand what is driving organic food and beverage market growth."],
  ["B", "Meaningful connections", "Build", "Make new contacts with the business leaders shaping organic food and beverage trade."],
  ["C", "New opportunities", "Capture", "Explore future supply and demand trends across the organic food and beverage market."],
  ["D", "Fresh perspectives", "Discover", "Get up to date with emerging trends and organic food and beverage technologies."],
  ["E", "Collaboration", "Examine", "Explore techno-commercial collaborations, joint ventures and new business possibilities."],
];

export function Reasons() {
  return (
    <section id="why-attend" data-testid="reasons-section" className="bg-[#eaeadd] py-20 lg:py-28">
      <div className="wrap">
        <Reveal className="grid items-end gap-6 lg:grid-cols-[1fr_1fr]">
          <div>
            <div className="eyebrow text-[#5c6b5a]">Rooted in opportunity</div>
            <h2 className="mt-4 font-display text-3xl sm:text-5xl">
              Key Reasons <em className="italic">To Attend.</em>
            </h2>
          </div>
          <p className="text-[15px] font-bold text-[#5c6b5a] lg:text-right">
            Five reasons to be in the room.
            <br />A world of possibilities to take away.
          </p>
        </Reveal>
        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {REASONS.map(([letter, small, title, copy], i) => (
            <Reveal key={letter} delay={i * 0.06} className={i === 0 ? "md:col-span-2 lg:col-span-1" : ""}>
              <article className="group h-full rounded-xl p-6 transition-transform duration-300 hover:-translate-y-1" style={{ background: "#fbfbf4", border: "1px solid var(--line)" }} data-testid={`reason-card-${letter.toLowerCase()}`}>
                <span className="font-display text-3xl italic opacity-30">{letter}</span>
                <small className="eyebrow mt-3 block text-[#5c6b5a]">{small}</small>
                <h3 className="mt-1 font-display text-2xl">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#3d5247]">{copy}</p>
                <span className="mt-4 inline-block transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">↗</span>
              </article>
            </Reveal>
          ))}
          <Reveal delay={0.3} className="md:col-span-2 lg:col-span-1">
            <div className="grid h-full place-items-center rounded-xl p-6 text-center" style={{ background: "var(--forest)" }}>
              <div>
                <span className="text-3xl text-[#d7ef8b]">✳</span>
                <p className="mt-3 text-[12px] font-extrabold tracking-[0.16em] text-[#f3f3e9]">
                  GROW YOUR
                  <br />
                  ORGANIC NETWORK
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
